const InfoRow = ({ label, value }) => (
  <div className="flex gap-2">
    <div className="w-24 shrink-0 text-gray-500">{label}</div>
    <div className="min-w-0 text-gray-800 wrap-break-word">{value}</div>
  </div>
)

export default InfoRow